<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="subjects"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="subjectTypesState.loading"
          :style="{ opacity: subjectTypesState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay destinos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      subjects: [],
      externDataForms: [
        'input-doc-form',
        'interno',
        'externo',
        'draftTray',
        'edit',
        'input-metadata-form'
      ]
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('List', ['subjectTypesState']),
    ...mapGetters('Dnts', ['documentTypeSelected']),
    optionSelected() {
      return this.subjectTypesState.list.find((option) => option.value === this.value);
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isDisabled() {
      return this.disabled
        || !this.subjectTypesState.list.length
        || this.subjectTypesState.loading;
    },
    hideOptions() {
      const formType = this.$route.path.split('/');
      return this.externDataForms.includes(formType[formType.length - 1]);
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event?.value);
    },
    getOption() {
      return this.subjectTypesState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    const { wizard } = this.$route.params;
    const internSubjects = ['usuarios', 'unidades', 'oficinas'];
    if (wizard && (wizard.includes('interno') || wizard.includes('externo') || wizard.includes('ddExterno'))) {
      this.subjects = this.subjectTypesState.list
        .filter((subject) => internSubjects.includes(subject.value))
        .filter((subject) => subject.value !== 'comisiones' && subject.value !== 'sanitarias');
      if (wizard && (wizard.includes('interno') && this.isSiss)) {
        this.subjects = this.subjectTypesState.list
          .filter((subject) => subject.value !== 'comisiones' && subject.value !== 'ministerios' && subject.value !== 'docDigital');
      }
    } else if (this.hideOptions) {
      this.subjects = this.subjectTypesState.list
        .filter((subject) => !subject.value
          .match(/docDigital|ministerios|personas|empresas|personasJuridicas|organismoEstado/i));
    } else {
      if (!this.isSiss) {
        this.subjects = this.subjectTypesState.list
          .filter((subject) => subject.value !== 'comisiones' && subject.value !== 'sanitarias');
        return;
      }
      this.subjects = this.subjectTypesState.list
        .filter((subject) => subject.value !== 'comisiones' && subject.value !== 'ministerios');
      if (!this.documentTypeSelected?.extra?.idDocDigital && !this.isDocDigital) {
        this.subjects = this.subjectTypesState.list
          .filter((subject) => subject.value !== 'docDigital');
      }
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Destino' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true },
    isDocDigital: { type: Boolean, default: false }
  }
};

</script>
